import type { Title } from "@/mocks/titles";
import PosterCard from "@/components/base/PosterCard";

interface Props {
  items: Title[];
  showRank?: boolean;
}

export default function PosterGrid({ items, showRank = false }: Props) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-6">
      {items.map((item, index) => (
        <PosterCard key={item.id} item={item} rank={showRank ? index + 1 : undefined} />
      ))}
    </div>
  );
}